import type { TOC } from "@ember/component/template-only";
import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";

export interface DropdownItemSignature {
  Args: object;
  Blocks: {
    default: [];
  };
  Element: HTMLButtonElement;
}
const DropdownItem: TOC<DropdownItemSignature> = <template>
  <button
    class="w-full px-2.5 py-2.5 pr-8 whitespace-nowrap text-sm text-gray-800 hover:text-black flex items-center disabled:opacity-50 focus:bg-gray-200 hover:bg-gray-200 cursor-pointer disabled:cursor-not-allowed"
    role="menuitem"
    type="button"
    tabindex="-1"
    {{mergeClasses}}
    ...attributes
  >
    {{yield}}
  </button>
</template>;

export default DropdownItem;
